module.exports = __webpack_public_path__ + "static/img/product_dianhanIntro.07759aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_dianhanIntro.jpg
// module id = i1Ud
// module chunks = 0